
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.479 19.167l-.367-2.934a3.467 3.467 0 01-.56-.275 7.52 7.52 0 01-.517-.343L3.308 16.76l-2.52-4.354 2.36-1.787a2.193 2.193 0 01-.023-.31V9.69c0-.099.007-.202.023-.309L.788 7.594l2.52-4.354 2.727 1.145c.168-.122.344-.236.527-.343.184-.107.367-.199.55-.275L7.48.833h5.042l.366 2.934c.199.076.386.168.562.275.176.107.347.221.515.343l2.728-1.145 2.52 4.354-2.36 1.787c.015.107.023.21.023.31v.618c0 .1-.015.203-.046.31l2.36 1.787-2.52 4.354-2.705-1.145a6.261 6.261 0 01-.527.343 4.632 4.632 0 01-.55.275l-.366 2.934H7.479zm2.567-5.959c.886 0 1.642-.313 2.268-.94.627-.626.94-1.382.94-2.268 0-.886-.313-1.642-.94-2.269a3.091 3.091 0 00-2.268-.94c-.902 0-1.662.314-2.281.94A3.111 3.111 0 006.837 10c0 .886.31 1.642.928 2.269.62.626 1.38.94 2.28.94z"}})])
          )
        }
      }
    